var _defs, _path, _path2, _polygon, _rect, _rect2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPyxis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1057.6 194.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M76.2,37.2c-38.1,0-55.8,8-63.8,20l-1.3-17.1H0v154.7h14.8v-55.3c8.8,10.4,26.5,17.3,61.4,17.3,64.6,0,76.2-22.5,76.2-47.2v-25.3c-.1-24.7-11.6-47.1-76.2-47.1h0ZM137.6,108.8c0,17.3-5.1,35.2-61.4,35.2S14.8,125.9,14.8,108.4v-22.7c0-17.5,5.1-35.6,61.4-35.6s61.4,18,61.4,35.3v23.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.4,138l-69.4-98.4h-17.6l77.9,111-12,15.9c-7.6,10.1-16.2,15.4-32.7,15.4h-8.2v12.9h8.2c29.7,0,39.5-12.8,49.7-27.4l88.3-127.8h-17.6l-66.6,98.4h0Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "503.5 39.6 447.6 88.2 392.7 39.6 371.4 39.6 437.5 96.8 371.5 154.1 391.7 154.1 447.6 105.3 502.6 154.1 523.8 154.1 457.7 96.8 523.8 39.6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 552.7,
    width: 14.8,
    height: 16.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 552.7,
    y: 39.8,
    width: 14.8,
    height: 114.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M626.1,73.8v-4.1c0-10.8,8.8-20,59.4-20s59.3,11.3,59.3,22.5v8.2h14.8v-9.2c0-18.6-16.9-34.6-74.1-34.6s-74.2,13.9-74.2,32.2v6.8c0,44.8,135.6,14.2,135.6,44.4v4.2c0,10.5-8.8,19.9-61.4,19.9s-61.4-11.2-61.4-22.5v-8.2h-14.8v9.1c0,18.6,16.9,34.6,76.2,34.6s76.2-14.1,76.2-32.1v-6.9c0-45.1-135.6-14.3-135.6-44.3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M966.6,3.5c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9S1016.8,3.5,966.6,3.5ZM997.3,63.8l-10.5,17.1c-1.7-2.6-4-4.8-6.6-6.6,0,0,17.1-10.5,17.1-10.5ZM897.6,94.2l47.8-11.5c-1.9,3.4-2.9,7.4-2.9,11.5s1.1,8.1,2.9,11.5l-47.8-11.5ZM935.9,125.2l10.5-17.7c1.8,2.7,4,5,6.6,6.8,0,0-17.1,10.9-17.1,10.9ZM946.4,80.9l-10.5-17.1,17.1,10.5c-2.6,1.7-4.8,4-6.6,6.6ZM966.9,163.5l-11.5-47.8c3.4,1.9,7.4,2.9,11.5,2.9s8-1.1,11.5-2.9l-11.5,47.8ZM966.9,70.3c-4.2,0-8.1,1.1-11.5,2.9l11.5-48.4,11.5,48.4c-3.4-1.8-7.3-2.9-11.5-2.9ZM980.2,114.3c2.6-1.8,4.8-4.1,6.6-6.8l10.5,17.7s-17.1-10.9-17.1-10.9ZM987.9,105.7c1.9-3.4,2.9-7.3,2.9-11.5s1.1-8.1,2.9-11.5l47.8,11.5-47.8,11.5h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyxis);
export default __webpack_public_path__ + "static/media/pyxis.3eab0f22369eb72f4a7d889eaec2858f.svg";
export { ForwardRef as ReactComponent };